<template>
    <div id="container">
        <!-- <div class="center-screen">
            <div class="logo">
                <img class="img_size" src="../assets/img/zhulia-01.png" />
            </div>
            
            <div style="display: flex; justify-content: space-around;">
                <a-button @click="showSignupPage" style="width: 400px;margin:40px;height: 50px;border-raduis:5px; background: #418a49; color:#fff;">
                    Signup
                </a-button>
                <a-button @click="showLoginPage" style="width: 400px;margin:40px;height: 50px;border-raduis:5px; background: #418a49; color:#fff;">
                    Login
                </a-button>
            </div>
        </div> -->
        
        <div>
        <a-layout style="background:#fff;">
                <a-layout-header class="header" :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
                
                    <div style="display:flex;justify-content: space-between;margin: 0 auto; width: 87%; max-width:87% ">
                        <h2 style="font-weight:800;padding-top:10px;font-size:30px;color:#232f3e;font-family: system-ui;"> Zhulia Seller </h2>
                        
                        <div style="display:flex;justify-content: space-between;padding-top:10px ">
                            <a-button @click="showSignupPage" class="loginButton">
                                Sign up
                            </a-button>
                            <a-button @click="showLoginPage" style="margin-left:10px" class="loginButton">
                                Login
                            </a-button>
                        </div>
                        
                    </div>
                    <div>
                        
                    </div>
                </a-layout-header>
                <a-layout-content :class="content">
                    <a-row style="padding-bottom:90px" type="flex" justify="center" align="middle">
                        <a-col :span="12">
                            <div>
                                <h1 class="section_1">
                                    Become a
                                    <br>
                                    Zhulia Seller
                                </h1>
                                <p style="color:#6c7778;font-size:20px;line-height:30px;font-weight:400;">More than half the units sold in our stores are
                                    <br/>
                                    from independent sellers.
                                </p>
                                <div style="padding-top:20px">
                                    <a-button @click="showSignupPage" class="loginButton">
                                        Sign up
                                    </a-button>
                                    <a-button @click="showLoginPage" style="margin-left:10px" class="loginButton">
                                        Login
                                    </a-button>
                                </div>
                            </div>   
                        </a-col>
                        <a-col :span="12">
                            <div style="display:flex;justify-content: center;">
                                <img class="img_size" src="../assets/img/seller-01.png"/>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row style="margin-right:-20px;padding-top:40px" type="flex">
                        <a-col style="background:#cccccc59;padding:30px;border-radius:6px;border: 1px solid #8888;" :span="7">
                            <div style="display:flex;justify-content: start;">
                                <img class="img_size_2" src="../assets/img/group_2.png"/>
                            </div>
                            <div style="float:right;padding-top:30px">
                                <h4 style="font-size:32px;line-height:38px;font-weight:800;color:#232f3e;font-family: system-ui;">Sell more</h4>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                            </div>
                            
                        </a-col>
                        <a-col style="background:#cccccc59;padding:30px;border-radius:6px;border: 1px solid #8888;"  :span="7" :offset="1" >
                            <div style="display:flex;justify-content: start;">
                                <img class="img_size_2" src="../assets/img/group_2.png"/>
                            </div>
                            <div style="float:right;padding-top:30px">
                                <h4 style="font-size:32px;line-height:38px;font-weight:800;color:#232f3e;font-family: system-ui;">Sell more</h4>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                            </div>
                        </a-col>
                        <a-col style="background:#cccccc59;padding:30px;border-radius:6px;border: 1px solid #8888;"  :span="7" :offset="1">
                            <div style="display:flex;justify-content: start;">
                                <img class="img_size_2" src="../assets/img/group_2.png"/>
                            </div>
                            <div style="float:right;padding-top:30px">
                                <h4 style="font-size:32px;line-height:38px;font-weight:800;color:#232f3e;font-family: system-ui;">Sell more</h4>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                </p>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row style="margin-top:120px" type="flex">
                        <a-col :span="7" >
                            <div style="display:flex;justify-content: center;">
                                <img class="img_size_3" src="../assets/img/phone.jpg"/>
                            </div>
                        </a-col>
                        <a-col style="padding:30px;border-radius:6px" :span="15" :offset="1">
                            <div style="display:flex;justify-content: start;">
                                <img class="img_size_2" src="../assets/img/left-quotes-sign.png"/>
                            </div>
                            <div style="font-size:32px;line-height:38px;color:#232f3e;padding-top:10px">
                                With all the infrastructure, systems, and processes Zhulia built I realized that selling efficiency is no longer a problem.
                            </div>
                            <div style="display:flex;padding-top:20px;">
                                <img class="img_size_4" src="../assets/img/cowtribe_logo.png"/>
                                <div style="display:flex;flex-direction:column;padding-left: 20px">
                                    <strong style="font-size:24px;line-height:36px">Agrovet 1</strong>
                                    <span style="color:#6c7778">Agrovet 2</span>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                    <a-row style="margin-bottom:80px;margin-top:90px" type="flex" justify="center" align="middle">
                        <a-col :span="12">
                            <div>
                                <h3 style="font-size:54px;line-height:76px;font-weight:800;color:#232f3e;font-family: system-ui;">Start selling today </h3>
                                <h4 style="color:#6c7778;font-size:20px;line-height:30px">Put your products in front of more than 300
                                    <br/>
                                    million customers worldwide
                                </h4>
                                <div style="padding-top:20px">
                                    <a-button @click="showSignupPage" class="loginButton">
                                        Sign up
                                    </a-button>
                                    <a-button @click="showLoginPage" style="margin-left:10px" class="loginButton">
                                        Login
                                    </a-button>
                                </div>
                            </div>   
                        </a-col>
                        <a-col :span="12">
                            <div style="display:flex;justify-content: center;">
                                <img class="img_size" src="../assets/img/seller-01.png"/>
                            </div>
                        </a-col>
                    </a-row>
                    
                   
                </a-layout-content>
            </a-layout>
        </div>
        <div class="footer">&#169; {{currentYear}} All Right Reserved Cowtribe</div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
    export default {
        name:"LandingPage",
        data(){
            return{
                content: 'content'
            }
        },
        computed:{
            ...mapGetters(['IsAgentProfileAvailable','isLoggedIn']),
            currentYear(){
                return moment().format("YYYY");  
            }
        },
        methods:{
            showLoginPage(){
                this.$router.push('/login').catch(()=>{});
            },
            showSignupPage(){
                this.$router.push('/signup').catch(()=>{});
            }
        },
        created(){
            // if(this.IsAgentProfileAvailable && this.isLoggedIn){
            //     if(this.isLoggedIn && this.IsAgentProfileAvailable.roleIds.some(role => role === process.env.VUE_APP_SUPER_ADMIN || role === process.env.VUE_APP_CLIENT) && this.IsAgentProfileAvailable.isActive){
            //         this.$router.push('/overview').catch(()=>{});
            //     }else{
            //         this.$router.push('/login').catch(()=>{});
            //     }
            // }else{
            //     this.$router.push('/login').catch(()=>{});
            // }
        }
    }
</script>

<style scoped>

.logo {
    width: 20%;
    height: 100%;
}

.logo img{
    width: 100%;
    height: auto;
    text-align: center;
}

.firstRow{
    display: flex;
    justify-content: space-between;
}

.header{
    display: flex;
    justify-content: space-between;
}
.footer{
  position: absolute;
  /* bottom: 0; */
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
}

.ant-layout-header{
    background: #fff;
    /* box-shadow: #00000033 */
    box-shadow: 0 0 24px rgb(0 0 0 / 20%);
}

.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  /* min-height: 50%; */
}

.background{
    background-image: url('../assets/img/background.svg');
    background-repeat: no-repeat;
    height: 600px;
    /* transform: scaleX(-1); */
}

.loginButton{
    width: 180px;
    height: 45px;
    background-color: #418a49;
    color: #fff;
    border-radius: 5px;
    font-size: 18px;
  
}

.img_size{
    max-height: 88%;
    max-width: 88%;
    margin: 0 auto;
}
.img_size_5{
    max-height: 100%;
    max-width: 100%;
}
.img_size_2{
    max-height: 67px;
    max-width: 67px;
}
.img_size_4{
    max-height: 67px;
    max-width: 67px;
    border-radius: 32px;
 
}
.img_size_3{
    max-height: 100%;
    max-width: 100%;
   
}
/* .background::before{
    content: "";
    position: absolute;
    width: 200%;
    height: 200%;
    top: -50%;
    left: -50%;
    z-index: -1;
    background: url('../assets/img/background.svg') 0 0 repeat;
    -webkit-transform: rotate(30deg);
    -moz-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    -o-transform: rotate(30deg);
    transform: rotate(180deg);
} */
/* 
#container .img_size{
    max-width: 75%;
    padding-bottom: 2px;
} */

.content{
    margin: 0 auto;
    width: 83%;
    margin-top: 100px;
}

.section_1{
    font-size:80px!important;
    line-height:96px;
    font-weight:900;
    color:#232f3e;
    font-family: system-ui;
}

@media all {
  .content{
        margin: 0 auto;
        width: 80%;
        margin-top: 100px;
    }
    .loginButton{
        width: 180px;
        height: 45px;
        background-color: #418a49;
        color: #fff;
        border-radius: 5px;
        font-size: 18px;
         
    }

    .section_1{
        font-size: 80px !important;
        line-height: 96px;
        font-weight: 900;
        color: rgb(35, 47, 62);
        font-family: system-ui;
    }
}



</style>